import { DateInputModule } from './../dateInput/date-input.mdl';
import { DateInputRange } from './date-input-range.cmp';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DateInputModule,

    ],
    exports: [
        DateInputRange
    ],
    declarations: [
        DateInputRange
    ]
})
export class DateInputRangeModule { }

